define(
({
  "load_error": "Chyba načítania",
  "description": "Žiadosť sa nedokončila správne. Mali by ste sa ubezpečiť, že vaša objednávka je uložená, a potom túto stránku obnoviť."
})
);
